import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.545 7.818c0-2.036 0-3.055.397-3.833A3.637 3.637 0 0 1 8.53 2.396C9.309 2 10.327 2 12.364 2h.763c3.106 0 4.659 0 5.845.604a5.545 5.545 0 0 1 2.423 2.424C22 6.214 22 7.767 22 10.873v2.254c0 3.106 0 4.659-.605 5.845a5.545 5.545 0 0 1-2.423 2.423C17.786 22 16.233 22 13.127 22h-.763c-2.037 0-3.055 0-3.833-.396a3.636 3.636 0 0 1-1.59-1.59c-.396-.777-.396-1.796-.396-3.832V7.818Zm9.93 2.489c.922.55 1.383.826 1.54 1.182a1.22 1.22 0 0 1 0 .977c-.157.356-.618.632-1.54 1.183l-2.44 1.457c-.964.575-1.446.863-1.842.826a1.216 1.216 0 0 1-.867-.492c-.235-.32-.235-.882-.235-2.005V10.52c0-1.123 0-1.684.236-2.005.205-.28.52-.459.866-.492.396-.037.878.25 1.842.826l2.44 1.458ZM4.273 7.49c0-2.24 0-3.36.436-4.216a4 4 0 0 1 .502-.758 5.545 5.545 0 0 0-2.606 2.51C2 6.215 2 7.768 2 10.874v2.254c0 3.106 0 4.659.604 5.845a5.545 5.545 0 0 0 2.607 2.51 3.993 3.993 0 0 1-.502-.757c-.436-.856-.436-1.976-.436-4.216V7.491Z",
      fill: "currentColor"
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const IconSocialVKVideo24 = createIcon(IconComponent);